import { useEffect, useMemo, useReducer } from 'react';

import { isExtraAccessActive, withExtraAccessPermissions } from '../user/extraAccess';

// The signed-in user with active extra access permissions added. At the end time the merge is
// recalculated by the clock (even if the refetch fails) and the user is refetched.
const useExtraAccessUser = (user, refetch) => {
	const until = user?.extraAccess?.until;
	const [, recheckClock] = useReducer(count => count + 1, 0);

	useEffect(() => {
		const msUntilEnd = until ? new Date(until).getTime() - Date.now() : 0;
		if (msUntilEnd <= 0) {
			return undefined;
		}

		const timeout = setTimeout(() => {
			recheckClock();
			refetch?.();
		}, msUntilEnd + 1000);
		return () => clearTimeout(timeout);
	}, [refetch, until]);

	const isActive = isExtraAccessActive(user?.extraAccess);

	return useMemo(() => (isActive ? withExtraAccessPermissions(user) : user), [user, isActive]);
};

export default useExtraAccessUser;
